import { useState } from "react";
import { KnowledgeBase, LoanHistory, Portfolio } from "@/components/credit/CreditReports";

const TABS = [["portfolio", "Portfolio report"], ["history", "Loan history (5 years)"], ["knowledge", "Knowledge base"]];

export default function CreditReportsPage() {
  const [tab, setTab] = useState("portfolio");
  return (
    <div className="flex-1 min-w-0 overflow-y-auto thin-scroll grid-bg" data-testid="credit-reports-page">
      <div className="px-5 sm:px-8 py-8 space-y-5 max-w-[1600px]">
        <div className="rise">
          <div className="chip border-sky-200 bg-sky-50 text-sky-700 mb-3"><span className="w-1.5 h-1.5 rounded-full bg-sky-500" />Credit reporting</div>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight hero-title pb-1">Credit reports & institutional memory</h1>
          <p className="text-sm text-slate-600 mt-2 max-w-3xl">Portfolio view of every loan and why it was decided, the bank's past loans and how they performed, and the knowledge base OmniFi uses when a file is incomplete. Each loan's own "Why this decision" report is on its Decision report tab.</p>
        </div>
        <div className="flex flex-wrap gap-1.5">{TABS.map(([k, l]) => <button key={k} data-testid={`cr-tab-${k}`} onClick={() => setTab(k)} className={`text-xs font-semibold px-3.5 py-2 rounded-xl border ${tab === k ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 text-slate-600"}`}>{l}</button>)}</div>
        {tab === "portfolio" && <Portfolio />}{tab === "history" && <LoanHistory />}{tab === "knowledge" && <KnowledgeBase />}
      </div>
    </div>
  );
}
